import { b64toBlob } from '~core';
import { getState } from '~src/state';
import { cleanBase64 } from '~src/utils';
import Swal from 'sweetalert2';
import { getUser } from '~src/user';
import { saveAs } from 'file-saver';
import { addWatermark } from '~src/utils';
import { getMetadata } from '~loader/loader-utils';
import slugify from 'slugify';
import { prepareCanvasVisualExportSelection } from './prepareCanvasVisualExportSelection';

export const handleDownloadSelection = async () => {
  const { selection } = prepareCanvasVisualExportSelection({
    canvas: window.canvas,
  });

  if (!selection) {
    // Button should be disabled if no selection, but just in case
    return;
  }

  const { user } = await getUser();
  const metadata = getMetadata();
  const downloadFileType = getState('submenu.export.downloadFileType') || 'PNG';

  const fileName = slugify(
    `${metadata.projectTypeName}-selezione${
      metadata.templatesCategoryName ? `-${metadata.templatesCategoryName}` : ''
    }${metadata.servizioName ? `-${metadata.servizioName}` : ''}${
      metadata.formatName ? `-${metadata.formatName}` : ''
    }`
  );

  Swal.fire({
    text: 'Sto esportando la selezione...',
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    confirmButtonColor: '#278e8e',
    didOpen: () => {
      Swal.showLoading();
    },
  });

  try {
    const imageBase64 = cleanBase64(selection.toDataURL());
    let finalImage = imageBase64.base64;

    if (user.org_pointer.tipo_istanza === 'demo') {
      const imageWithWatermark = await addWatermark(
        `data:${imageBase64.contentType};base64,${imageBase64.base64}`
      );
      finalImage = cleanBase64(imageWithWatermark).base64;
    }

    const fileExtension = downloadFileType.toLowerCase();
    const contentType =
      fileExtension === 'jpeg' ? 'image/jpeg' : `image/${fileExtension}`;
    const blob = b64toBlob(finalImage, contentType);

    saveAs(blob, `${fileName}.${fileExtension}`);

    Swal.hideLoading();
    Swal.fire({
      title: 'Fatto!',
      html: 'La selezione &egrave; stata scaricata.',
      icon: 'success',
      confirmButtonColor: '#278e8e',
    });

    setTimeout(() => {
      Swal.close();
    }, 2000);
  } catch (error) {
    console.error('Error downloading selection:', error);
    Swal.hideLoading();
    Swal.fire({
      title: 'Errore!',
      html:
        'Si &egrave; verificato un errore durante il download della selezione.',
      icon: 'error',
      confirmButtonColor: '#278e8e',
    });
  }
};

window.downloadSelection = handleDownloadSelection;
